import * as VueI18n from 'vue-i18n';
import plMessages from './locales/pl.json';
import enMessages from './locales/en.json';

const i18n = VueI18n.createI18n({
  locale: 'pl',
  fallbackLocale: 'en',
  messages: {
    pl: plMessages,
    en: enMessages
  }
});

export default i18n;
